import { Box, Typography } from '@mui/material';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { useSelector } from 'react-redux';
import useBillingStatus from '../../hooks/useBillingStatus';

/**
 * Wraps the ENTIRE storefront layout (header, content, footer): when the shop's
 * ZED subscription is Expired/Inactive and enforcement is on, customers see a
 * dominant full-screen "temporarily unavailable" page — no navbar, no menus,
 * nothing else to interact with. Active and Grace render the store normally.
 */
const BillingStatusGate = ({ children }) => {
    const { billingStatus, enforced, loaded } = useBillingStatus();
    const businessName = useSelector((store) => store.configs.businessName);

    if (!loaded) return children;

    if (enforced && (billingStatus === 'Expired' || billingStatus === 'Inactive')) {
        return (
            <Box sx={{
                position: 'fixed', inset: 0, zIndex: 2000, bgcolor: '#ffffff',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                textAlign: 'center', px: 3,
            }}>
                <StorefrontOutlinedIcon sx={{ fontSize: { xs: 80, md: 110 }, color: '#032541', mb: 3 }} />
                <Typography sx={{ fontWeight: 700, color: '#032541', mb: 2, fontSize: { xs: '26px', md: '36px' } }}>
                    {businessName ? `${businessName} is taking a short break` : 'This store is taking a short break'}
                </Typography>
                <Typography sx={{ color: '#707070', maxWidth: 560, fontSize: { xs: '15px', md: '18px' }, lineHeight: 1.6 }}>
                    We&apos;re temporarily unavailable while we carry out some housekeeping.
                    Please check back soon — we can&apos;t wait to serve you again!
                </Typography>
            </Box>
        );
    }

    return children;
};

export default BillingStatusGate;
